export default "__VITE_ASSET__kPKMEoTT__"